import { CAPABILITY_APM } from '@/utils/constants';
import home from '@/utils/templates/home.template';
import homeCharts from '@/utils/templates/home.template.charts';
import actions from '@/store/modules/global/app/app.actions';
import mutations from '@/store/modules/global/app/app.mutations';
import getters from './app.getters';
import { Permissions } from '@/utils/types/global';
import apm from '@/utils/templates/apm.template';
import browser from '@/utils/templates/browser.template';
import mobile from '@/utils/templates/mobile.template';
import vm from '@/utils/templates/vm.template';
import k8m from '@/utils/templates/k8m.template';

// import { mutations } from './app.mutations';
export interface State {
  currentSideNav: any;
  chartsTemplate: any;
  openMenu: Boolean;
  currentCapability: string;
  correlatedCapability: string;
  updateDashboard: any;
  hideDateTimePicker: Boolean;
  disableDateTimePickerOptions: Array<any>;
  isFormOpened: boolean;
  activeCapabilities: Array<any>;
  isForcastEnabled: boolean;
  isForecastModalEnable: boolean;
  isCompareCalendarEnabled: boolean;
  currLang: 'ja' | 'en' | string;
  permissions: Permissions | null;
  middlewareLoading: boolean;
  compareSupportedCapabilities: Array<string>;
}
const screenWidth = window.innerWidth;
const initialState: State = {
  currentSideNav: home,
  chartsTemplate: homeCharts,
  openMenu: screenWidth >= 1460 ? true : false,
  currentCapability: CAPABILITY_APM,
  correlatedCapability: '',
  updateDashboard: {},
  hideDateTimePicker: false,
  disableDateTimePickerOptions: [],
  isFormOpened: false,
  activeCapabilities: [],
  isForcastEnabled: false,
  isForecastModalEnable: false,
  isCompareCalendarEnabled: true,
  currLang: 'en',
  permissions: null,
  middlewareLoading: false,
  compareSupportedCapabilities: [
    apm.key,
    browser.key,
    mobile.key,
    vm.key,
    k8m.key,
  ],
};
export default {
  namespaced: true,
  state: initialState,
  mutations: mutations,
  actions,
  getters: getters,
};
